let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9XbfG")).then(() => parcelRequire('1TGyK'));